module.exports = __webpack_public_path__ + "static/transakcja-1842abb22ed9637d5f71c09cbbb64919.jpg";